import { component } from 'flightjs';
import WithAjax from 'static/script/app/data/with-ajax';

function FeatureFeedbackService() {
    this._submitFeedback = function(evt, payload) {
        this._post({
            url: '/feature-feedback/',
            data: payload,
            success: 'data:feature-feedback:after-submit',
            error: 'data:feature-feedback:on-submit-error'
        });
    };

    this.after('initialize', function() {
        this.on(document, 'data:feature-feedback:submit', this._submitFeedback);
    });
}

export default component(FeatureFeedbackService, WithAjax);
